import React from 'react'
import GamePortfolio from '../GamePortfolio/GamePortfolio'
import MobPortfolio from '../Mobile-Portfolio/MobPortfolio'
import WebPortfolio from '../Portfolio/WebPortfolio'

export const Service2 = () => {
  return (
    <>
    <WebPortfolio/>
    <MobPortfolio/>
    <GamePortfolio />
    </>
  )
}
